export default __webpack_public_path__ + "static/apple-icon-180x180-69e4540813e42fd1fa4216d1418f7e9e.png";